// extracted by mini-css-extract-plugin
export default {"label":"PeriodAndFrequency_label__+f+YG","fieldset":"PeriodAndFrequency_fieldset__raX20","caretDown":"PeriodAndFrequency_caretDown__mRn4h"};